import React from 'react';
import COLOR from '../../types/color-types';
var List = function (_a) {
    var items = _a.items, _b = _a.bulletColor, bulletColor = _b === void 0 ? COLOR.BACKGROUND : _b;
    return (React.createElement("div", { className: 'list' },
        React.createElement("ul", null, items.map(function (item) { return (React.createElement("li", { "data-bullet-color": bulletColor, key: item },
            React.createElement("span", null, item))); }))));
};
export default List;
